import React, { useMemo, useState } from "react"
import ReactApexChart from "react-apexcharts"
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import { Select } from "antd"

const { Option } = Select

dayjs.extend(customParseFormat)

const PayoutChart = ({ data }) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]

  // Extract unique years from data
  const years = useMemo(() => {
    const yearSet = new Set()
    data.forEach(entry => {
      let dateStr = entry.Date || entry.createdAt
      let parsedDate = dayjs(dateStr, ["DD/MM/YYYY", dayjs.ISO_8601], true)
      if (!parsedDate.isValid()) parsedDate = dayjs(dateStr)
      if (parsedDate.isValid()) {
        yearSet.add(parsedDate.year())
      }
    })
    return Array.from(yearSet).sort((a, b) => b - a) // Descending order
  }, [data])

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())

  // Calculate payouts for selected year
  const payouts = useMemo(() => {
    const monthlyPayouts = Array(12).fill(0)

    data.forEach(entry => {
      let dateStr = entry.Date || entry.createdAt
      let parsedDate = dayjs(dateStr, ["DD/MM/YYYY", dayjs.ISO_8601], true)
      if (!parsedDate.isValid()) parsedDate = dayjs(dateStr)

      if (parsedDate.isValid() && parsedDate.year() === selectedYear) {
        const monthIndex = parsedDate.month() // 0 = Jan
        const debit = parseFloat(entry.Debit)
        if (!isNaN(debit)) {
          monthlyPayouts[monthIndex] += debit
        }
      }
    })

    return monthlyPayouts.map(value => Number(value.toFixed(2)))
  }, [data, selectedYear])

  const chartData = {
    series: [
      {
        name: "Payout (INR)",
        data: payouts,
      },
    ],
    options: {
      xaxis: {
        categories: months,
        title: {
          text: "Month",
          offsetY: 90,
          style: {
            color: "#000",
            fontSize: "14px",
            fontWeight: 600,
          },
        },
        labels: {
          style: {
            colors: Array(months.length).fill("#000"),
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        title: {
          text: "Payout (₹)",
          style: {
            color: "#000",
            fontSize: "14px",
            fontWeight: 600,
          },
        },
        labels: {
          style: {
            colors: Array(10).fill("#000"),
            fontSize: "12px",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          columnWidth: "50%",
        },
      },
      colors: ["#302B67"],
    },
  }

  return (
    <div className="p-4 Card-Data rounded-3">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="ms-4">Yearly Payout Summary ({selectedYear})</h4>
        <Select
          value={selectedYear}
          onChange={setSelectedYear}
          size="small"
          style={{ width: 100 }}
          className="ms-2"
        >
          {years.map(month => (
            <Option key={month} value={month}>
              {month}
            </Option>
          ))}
        </Select>
      </div>

      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  )
}

export default PayoutChart
